import { isDeveloper } from "@/hooks/useAuth"
import { createFileRoute, redirect } from "@tanstack/react-router"

// TODO uncomment when user got access here. Experimental feature.

export const Route = createFileRoute(
  "/dashboard/temperatures/$unitSerialNumber",
)({
  beforeLoad: () => {
    if (!isDeveloper()) {
      throw redirect({ to: "/" })
    }
  },
})
